/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { GridSet, GridItem, TextField, SelectableList, Tip, DateRangePickerDropDown } from '@insticator/insticator-ui'; // iui-materialimport {  } from '@insticator/insticator-ui'; // iui-material
import Area from 'pages/dashboard/reports/detail/area/area';
//utils
import { isAfterFourPM, zeroPadding } from '@insticator/insticator-ui'; // iui-utils
import { validation } from 'utils/validation';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/settings/settings_styles';



/* ========== ~~~~~~~~~~ REPORT SETTINGS ~~~~~~~~~~ ========== */
const ReportSettings = (props) => {
    const rangeFormat = (range) =>{
        let { to, from } = range;
        return ({ from:`${from.getFullYear()}-${zeroPadding((from.getMonth() + 1), 2)}-${zeroPadding(from.getDate(), 2)}`,
            to:`${to.getFullYear()}-${zeroPadding((to.getMonth() + 1), 2)}-${zeroPadding(to.getDate(), 2)}` });
    };
    return (
        <Area name={`settings`} klass = {`${props.classes.settings}`} title = {`Report Settings`}>
            <GridSet klass={'settings_content'} direction = {`vertical`}>
                <GridItem klass={`settings_section`}>
                <p className={`settings_subheading`}>Name your report:</p>
                <TextField  klass={'report_name'}
                        type={'text'}
                        name={'reportName'}
                        value={props.name}
                        placeholder={`E.g 'Last 7 days daily report'`}
                        handleBlur={(event) =>  props.setReportProperties({selectedReportDataValid: Object.assign({}, props.valid, { settings: validation.reportName.test.test(event.target.value)}),
                                                  name: event.target.value})}
                        handleChange={(event) => props.setReportProperties({selectedReportDataValid: Object.assign({}, props.valid, { settings: validation.reportName.test.test(event.target.value)}),
                                                  name: event.target.value})}
                        valid={props.valid.settings}
                        required
                    />
                </GridItem>
                <GridItem klass={'settings_section'}>
                <p className={'settings_subheading'}>Select a date range:
                    <Tip space={`left`}
                         content = {<p>Select the date range that you want your report to cover. All data displayed and available is in EST time zone.</p>}/></p>
                <SelectableList type={'radio'}
                      items={[{ value: 'YESTERDAY', text: <span>Yesterday <Tip icon={'exclamation-circle'} space={`none`} content={<p>{`Report data for this selection is only available after 5:30pm EDT`}</p>}/></span>},
                                { value: 'LAST_SEVEN_DAYS', text: 'Last 7 Days' },
                                { value: 'LAST_THIRTY_DAYS', text: 'Last 30 Days' },
                                { value: 'LAST_WEEK', text: 'Last week (Monday - Sunday)' },
                                { value: 'LAST_MONTH', text: 'Last month (first to last days of month)' },
                                { value: 'CUSTOM', text: <span>Custom <Tip icon={'exclamation-circle'} space={`none`} content={<p>{`You will not be able to schedule recurring reports for this option`}</p>}/></span>}]}
                        selected={props.dateRange}
                        handleChange={newDateRange => props.dateRange !== newDateRange ? props.setReportProperties({dateRange: newDateRange}) : null} />
                {props.dateRange === 'CUSTOM' ?
                <DateRangePickerDropDown klass={'date_picker'}
                                         alignedRight={true}
                                         hideDateRangeHelpers={true}
                                         hideButtons={true}
                                         range={props.customDateRange}
                                         updateRange={(customDateRange)=>{props.setReportProperties({customDateRange: customDateRange})}}
                                         disabledDays={[ { after: new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]}
                /> : null}
                </GridItem>
            </GridSet>
        </Area>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportSettings);
